import React from 'react';
import Container from '@amzn/awsui-components-console/container';
import { StringGroup } from '../types';
import { formatDayMonthYear } from 'src/common/utils/dateFormatters';
import styles from '../StringGroupDetail.module.scss';
import { getClientDisplayName } from 'src/features/string-group-detail/utils/clientIdMapper';
interface MetadataPanelProps {
  group: StringGroup;
}

const NOT_AVAILABLE = '—';

/**
 * Formats an epoch-millis timestamp as "DD Mon YYYY". `useStringGroupData`
 * defaults missing server timestamps to 0, which would otherwise render as
 * 01 Jan 1970.
 */
function formatDate(timestamp: number): string {
  if (!timestamp) {
    return NOT_AVAILABLE;
  }
  return formatDayMonthYear(new Date(timestamp));
}

/** Renders "<date> by <user>", omitting either part when it is unavailable. */
function formatDateWithActor(timestamp: number, actor: string): string {
  const date = formatDate(timestamp);
  if (!actor) {
    return date;
  }
  return date === NOT_AVAILABLE ? actor : `${date} by ${actor}`;
}

const MetadataPanel: React.FC<MetadataPanelProps> = ({ group }) => (
  <Container>
    <div className={styles.metadataBody}>
      <div className={styles.metadataRow}>
        <span className={styles.metadataLabel}>CX Family</span>
        <span className={styles.metadataValue}>{group.cxFamilyId}</span>
      </div>
      <div className={styles.metadataRow}>
        <span className={styles.metadataLabel}>CX IDs</span>
        <span className={styles.metadataValue}>{group.cxIds.join(', ')}</span>
      </div>
      <div className={styles.metadataRow}>
        <span className={styles.metadataLabel}>Source Locale</span>
        <span className={styles.metadataValue}>{group.sourceLocale}</span>
      </div>
      <div className={styles.metadataRow}>
        <span className={styles.metadataLabel}>Team Name</span>
        <span className={styles.metadataValue}>
          {group.teamName ?? NOT_AVAILABLE}
        </span>
      </div>
      <div className={styles.metadataRow}>
        <span className={styles.metadataLabel}>Source</span>
        <span className={styles.metadataValue}>
          {getClientDisplayName(group.clientId)}
        </span>
      </div>
      <div className={styles.metadataRow}>
        <span className={styles.metadataLabel}>Group Created On</span>
        <span className={styles.metadataValue}>
          {formatDateWithActor(group.createdOn, group.createdBy)}
        </span>
      </div>
      <div className={styles.metadataRow}>
        <span className={styles.metadataLabel}>Group Updated On</span>
        <span className={styles.metadataValue}>
          {formatDateWithActor(group.updatedOn, group.updatedBy)}
        </span>
      </div>
      <div className={styles.metadataRow}>
        <span className={styles.metadataLabel}>
          Last Translation Submitted On
        </span>
        <span className={styles.metadataValue}>{NOT_AVAILABLE}</span>
      </div>
    </div>
  </Container>
);

export default MetadataPanel;
